<template>
  <el-dialog
    title="修改"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :visible.sync="dialogFormVisible"
    width="50%"
    @close="closeDialog"
  >
    <el-form
      ref="form"
      label-position="right"
      :model="form"
      :rules="rules"
      :label-width="formLabelWidth"
      id="form"
    >
      <el-form-item label="开始时间" prop="startTime">
        <el-col :span="18">
          <el-date-picker
            v-model.trim="form.startTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择结束时间"
          >
          </el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime">
        <el-col :span="18">
          <el-date-picker
            v-model.trim="form.endTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择结束时间"
          >
          </el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="消息" prop="message">
        <el-col :span="18">
          <el-input clearable v-model.trim="form.telephone"></el-input>
        </el-col>
      </el-form-item>

      <el-form-item label="排序" prop="sequence">
        <el-col :span="18">
          <el-input clearable v-model.trim="form.sequence"></el-input>
        </el-col>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog('normal')">取 消</el-button>
      <el-button type="primary" @click="addrOrEditTrue()">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { publishMessageCud } from "@/api/url";
export default {
  name: "mini-program-message-release-edit",
  props: ["detail"],
  data() {
    return {
      dialogFormVisible: true,
      form: {
        merchantName: "",
        contacts: "",
        telephone: "",

        picture: "",
        url: "",
        remark: "",
      },
      formLabelWidth: "120px",
    };
  },
  mounted() {
    if (this.detail) {
      this.form = JSON.parse(JSON.stringify(this.detail));
    }
  },
  methods: {
    closeDialog(type) {
      this.$emit("closeDialog", type);
    },
    addrOrEditTrue() {
      this.$putRequest(`${publishMessageCud()}//${this.form.id}`, {
        ...this.form,
      }).then((res) => {
        if (res.status == 200) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.closeDialog("add");
        } else {
          this.$message({
            type: "error",
            message: "修改失败",
          });
        }
      });
    },
   
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>